import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithBackground.js";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";

const Container = tw.div`relative`;
const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24 px-4 sm:px-6 lg:px-8`;
const Section = tw.section`mb-12`;
const SectionHeading = tw.h2`text-2xl md:text-3xl font-bold text-gray-900 mb-4 mt-8`;
const SubHeading = tw.h3`text-xl font-semibold text-gray-800 mb-2 mt-6`;
const Paragraph = tw.p`text-gray-700 mb-4`;
const List = tw.ul`list-disc list-inside text-gray-700 mb-4`;
const ListItem = tw.li`mb-1`;
const ContactInfo = tw.div`mb-4`;
const Link = tw.a`text-primary-500 underline hover:text-primary-700`;

export default () => (
  <AnimationRevealPage>
    <Header />
    <Container>
      <ContentWithPaddingXl>
        <Section>
          <SectionHeading>Protection des Données Personnelles (RGPD)</SectionHeading>
          <Paragraph>
            Tanga Africa. s'engage à protéger vos données personnelles et à respecter vos droits en matière de protection des données. Cette page vous informe sur la manière dont nous collectons, utilisons et protégeons vos données personnelles conformément au Règlement Général sur la Protection des Données (RGPD), à la loi n°2013-450 du 19 juin 2013 relative à la protection des données à caractère personnel, et sous la supervision de l'ARTCI (Autorité de Régulation des Télécommunications/TIC de Côte d'Ivoire).
          </Paragraph>
        </Section>

        <Section>
          <SubHeading>Responsable du Traitement</SubHeading>
          <ContactInfo>
            <Paragraph>
              <strong>Tanga Africa</strong><br />
              Cocody Riviera Akouedo<br />
              Abidjan, Côte d'Ivoire<br />
              Email : <Link href="mailto:privacy@tangagroup.africa">privacy@tangagroup.africa</Link><br />
              Téléphone : +225 27 22 49 49 49
            </Paragraph>
          </ContactInfo>
        </Section>

        <Section>
          <SubHeading>Données Personnelles Collectées</SubHeading>
          <List>
            <ListItem>Informations d'identification (nom, prénom, email, téléphone)</ListItem>
            <ListItem>Informations professionnelles (poste, entreprise)</ListItem>
            <ListItem>Données de connexion et d'utilisation</ListItem>
            <ListItem>Données de localisation</ListItem>
          </List>
        </Section>

        <Section>
          <SubHeading>Finalités du Traitement</SubHeading>
          <List>
            <ListItem>Fournir et améliorer nos services</ListItem>
            <ListItem>Gérer votre compte utilisateur</ListItem>
            <ListItem>Communiquer avec vous</ListItem>
            <ListItem>Personnaliser votre expérience</ListItem>
            <ListItem>Respecter nos obligations légales</ListItem>
          </List>
        </Section>

        <Section>
          <SubHeading>Base Légale du Traitement</SubHeading>
          <List>
            <ListItem>Votre consentement</ListItem>
            <ListItem>L'exécution d'un contrat</ListItem>
            <ListItem>Le respect d'une obligation légale</ListItem>
            <ListItem>Notre intérêt légitime</ListItem>
          </List>
        </Section>

        <Section>
          <SubHeading>Durée de Conservation</SubHeading>
          <Paragraph>
            Vos données personnelles sont conservées pendant la durée nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées, conformément à la législation en vigueur.
          </Paragraph>
        </Section>

        <Section>
          <SubHeading>Vos Droits</SubHeading>
          <Paragraph>
            Vous disposez des droits suivants concernant vos données personnelles :
          </Paragraph>
          <List>
            <ListItem>Droit d'accès</ListItem>
            <ListItem>Droit de rectification</ListItem>
            <ListItem>Droit à l'effacement</ListItem>
            <ListItem>Droit à la limitation du traitement</ListItem>
            <ListItem>Droit d'opposition</ListItem>
            <ListItem>Droit à la portabilité</ListItem>
          </List>
          <Paragraph>
            Pour exercer vos droits, contactez-nous à l'adresse <Link href="mailto:privacy@tangagroup.africa">privacy@tangagroup.africa</Link>.
          </Paragraph>
        </Section>

        <Section>
          <SubHeading>Sécurité des Données</SubHeading>
          <Paragraph>
            Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour garantir la sécurité de vos données personnelles.
          </Paragraph>
        </Section>

        <Section>
          <SubHeading>Transferts de Données Hors de la Côte d'Ivoire</SubHeading>
          <Paragraph>
            Si vos données sont transférées hors de la Côte d'Ivoire, nous veillons à ce qu'elles bénéficient d'un niveau de protection adéquat.
          </Paragraph>
        </Section>

        <Section>
          <SubHeading>Autorité de Contrôle : ARTCI</SubHeading>
          <Paragraph>
            L'ARTCI (<Link href="https://www.autoritedeprotection.ci/" target="_blank" rel="noopener noreferrer">Autorité de Régulation des Télécommunications/TIC de Côte d'Ivoire</Link>) est l'autorité compétente en matière de protection des données personnelles en Côte d'Ivoire. Si vous estimez que vos droits ne sont pas respectés, vous pouvez contacter l'ARTCI ou introduire une réclamation via leur site officiel.
          </Paragraph>
        </Section>

        <Section>
          <SubHeading>Contact</SubHeading>
          <Paragraph>
            Pour toute question relative à la protection de vos données personnelles, contactez-nous à <Link href="mailto:hello@tangagroup.africa">hello@tangagroup.africa</Link>.
          </Paragraph>
        </Section>

        <Section>
          <SubHeading>Modification de la Politique</SubHeading>
          <Paragraph>
            Cette politique peut être modifiée à tout moment. Nous vous invitons à la consulter régulièrement.
          </Paragraph>
        </Section>
      </ContentWithPaddingXl>
    </Container>
    <Footer />
  </AnimationRevealPage>
); 